import { BrowserRouter, Routes, Route, HashRouter } from "react-router-dom";
import { AuthProvider } from "./context/loginContext.js";
import { BOsPlantilla } from "./context/dashboardContext.js";
import ProtectedRoutes from './protected/protectedRoutes.js';
import './App.css'
import Login from "./components/login/auth.js";
import Home from "./components/Home/Home.js";
import Tablero from "./components/Tableros/tablero.js";
import GestionAdmin from "./components/panel_control/gestion.js"

function App() {
  return (
    <>
      <AuthProvider>
        <HashRouter>
          <BOsPlantilla>
            <Routes>
              
              <Route exact path="/" element={<Login />} />
              <Route exact path="/login" element={<Login />} />

              {/** fuera del dash */}
              <Route element={<ProtectedRoutes />}>
                <Route exact path="/home" element={<Home />} />
                <Route exact path="/tablero" element={<Tablero />} />
                <Route exact path="/panel-control" element={<GestionAdmin />} />
              </Route>

            </Routes>
          </BOsPlantilla>
        </HashRouter>
      </AuthProvider>



    </>



  );
}

export default App;